import React from "react";
import SettingsPage from "../../../components/List/SettingsList"
import { useTranslation } from "react-i18next";

const EditItemCategorySettingsPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <SettingsPage
            title={t("common.itemCategory")}
            fetchUrl= "/itemApi/GetItemCategoryList"
            createOrUpdateUrl="itemApi/CreateOrUpdateItemCategory"
            deleteUrl="itemApi/DeleteItemCategory"
        
        />
    );
};

export default EditItemCategorySettingsPage;
